import { Box, Typography } from "@mui/material"
import { PropsWithChildren } from "react"
import { makeStyles } from "tss-react/mui"

export type TagSize = "sm" | "md"

type TagRoundedStyleProps = {
    size?: TagSize
}

const useStyles = makeStyles()((theme) => ({
    box: {
        display: "flex",
        borderRadius: "0.25rem",
        padding: "0 0.375rem",
        color: theme.palette.common.white,
        backgroundColor: theme.palette.tailwind.green[500],
    },
}))

const useTagRoundedStyles = makeStyles<TagRoundedStyleProps>()((theme, { size }) => {
    const dimension = size === "sm" ? "3.125rem" : "5rem"
    const padding = size === "sm" ? "0 0.5rem" : "0.375rem 0.75rem"

    return {
        container: {
            width: dimension,
            height: dimension,
            padding,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            wordWrap: "break-word",
            fontSize: "0.75rem",
            fontWeight: 500,
            borderRadius: "50%",
            textAlign: "center",
            fontFamily: theme.typography.fontFamily,
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
    }
})

type TagProps = Readonly<{
    children: string | JSX.Element | number | string[]
}>

export const Tag = ({ children }: TagProps) => {
    const { classes } = useStyles()

    return (
        <Box className={classes.box}>
            <Typography fontWeight={500} variant="caption">
                {children}
            </Typography>
        </Box>
    )
}

type TagRoundedProps = PropsWithChildren<{
    size?: TagSize
}>

export const TagRounded = ({ children, size = "md" }: TagRoundedProps) => {
    const { classes } = useTagRoundedStyles({ size })

    return <Box className={classes.container}>{children}</Box>
}
